import ko from "knockout";

export class AlertEntry {
  constructor(alertType, alertMessage) {
    this.alertType = alertType;
    this.alertMessage = alertMessage;
  }
}

export class AlertViewModel {
  constructor() {
    this.alerts = ko.observableArray();
  }

  /**
   * Add a timed alert that auto-dismisses after timeoutSeconds and shows a countdown.
   * @param {string} type   Alert type (Bootstrap alert-* classes)
   * @param {string} message  Message text
   * @param {number} timeoutSeconds  Seconds before auto-dismiss (default: 10)
   */
  addAlert(type, message, timeoutSeconds = 10) {
    const entry = new AlertEntry(type, message);
    // countdown observable
    entry.remainingSeconds = ko.observable(timeoutSeconds);
    this.alerts.push(entry);
    // start countdown timer
    const timer = setInterval(() => {
      const rem = entry.remainingSeconds() - 1;
      if (rem <= 0) {
        clearInterval(timer);
        this.alerts.remove(entry);
      } else {
        entry.remainingSeconds(rem);
      }
    }, 1000);
  }

  addError(message) {
    this.addAlert("danger", message);
  }

  addInfo(message) {
    this.addAlert("info", message);
  }

  addWarning(message) {
    this.addAlert("warning", message);
  }
}
